export enum EmployeeCategory {
  EMPLOYED = 'employed',
  ARCHIVED = 'archived',
}
